<template>
  <div class="Ftr-Links">
    <!------------------< DropsКлуб >-------------------->
    <div class="Ftr-Links__clmn Ftr-Links__clmn--drops">
      <p class="Ftr-Links__ttl">DropsКлуб</p>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.MAIN}">Инфошум</router-link>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.CALENDAR}">Календарь</router-link>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.FORECASTERS}">Форкастеры</router-link>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.SCANNER}">Скриннер</router-link>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.RULES.TERMS}">Правила</router-link>
      <router-link class="Ftr-Links__lnk" :to="{name: PATHS_NAME.FEEDBACK}">Обратная связь</router-link>
    </div>
    <!-------------------< Общение >--------------------->
    <div class="Ftr-Links__clmn Ftr-Links__clmn--community">
      <p class="Ftr-Links__ttl">Общение</p>
      <a class="Ftr-Links__lnk" href="https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxODkyMjYzODQ1" target="_blank" rel="nofollow">PoN Chat</a>
      <a class="Ftr-Links__lnk" href="https://twitter.com/ICODrops" target="_blank" rel="nofollow">Twitter</a>
      <a class="Ftr-Links__lnk" href="https://t.me/icodrops" target="_blank" rel="nofollow">Telegram News</a>
      <a class="Ftr-Links__lnk" href="https://t.me/joinchat/FoisO0k4-XXBkPEikfdgow" target="_blank">Telegram Chat (EN)</a>
      <a class="Ftr-Links__lnk" href="https://t.me/joinchat/FoisO0R8kn58iNNlqnNjlg" target="_blank">Telegram Chat (RU)</a>
      <a class="Ftr-Links__lnk" href="https://t.me/joinchat/FoisO1Ge70JnvvyaFMdBsQ" target="_blank">Cryptonarnia Chat (RU)</a>
      <a class="Ftr-Links__lnk" href="https://t.me/joinchat/FoisO1OCo4g1o6vyBNnJaw" target="_blank">DropsEarn Chat (RU)</a>
    </div>
    <!------------------< Экосистемам >------------------>
    <div class="Ftr-Links__clmn Ftr-Links__clmn--ecosystems">
      <p class="Ftr-Links__ttl">Экосистема</p>
      <a class="Ftr-Links__lnk" href="https://dropstab.com" target="_blank">DropsTab</a>
      <a class="Ftr-Links__lnk" href="https://dropsearn.com" target="_blank">DropsEarn</a>
      <a class="Ftr-Links__lnk" href="https://icodrops.com/" target="_blank">ICO Drops</a>
      <a class="Ftr-Links__lnk" href="https://t.me/icodrops_support" target="_blank">Напишите Нам</a>
    </div>
  </div>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
</script>

<style scoped lang="scss">
  @import './styles';
</style>